














































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";
import CategoryTypeInput from "../general/CategoryTypeInput.vue";

import SettingsJson from "../../shared/SettingsJson";
import { CategoryTypeType } from "../../shared/CategoryTypeType";
import {
  ClientMailingJson,
  defaultClientMailingJson,
  validateClientMailingRecipientJson,
  validateClientMailingRecipientJsonManagementAdd,
} from "../../shared/ClientJson";
import MailingRecipientJson from "../../shared/MailingRecipientJson";
import { MailingRecipientStatus, MailingRecipientStatusNames } from "../../shared/MailingRecipientStatus";
import MailingListJson from "../../shared/MailingListJson";
import { CreatedBy } from "../../shared/CreatedBy";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";

export default Vue.extend({
  name: "MailingsRecipientDetails",
  components: {
    OverlayWindow,
    Loading,
    CategoryTypeInput,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    clientMailingId: Number,
    mode: String,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      MailingRecipientStatus: MailingRecipientStatus,
      MailingRecipientStatusNames: MailingRecipientStatusNames,
      CategoryTypeType: CategoryTypeType,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      detailsMode: "",
      allMailingLists: null as MailingListJson[] | null,
      selectedClientMailingId: null as number | null,
      clientMailingDetails: null as ClientMailingJson | null,
      hasChanges: false,
      emailHasChanged: false,
      toValidate: {} as any,
      validation: null as ValidationResult<ClientMailingJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
      loadingNextup: false as boolean,
    };
  },
  created() {
    this.initClientMailingDetails();
  },
  mounted() {},
  methods: {
    initClientMailingDetails() {
      this.selectedClientMailingId = this.clientMailingId;

      this.loadMailingLists();
      this.loadClientMailingDetails();

      this.selectDetailsMode(this.mode);
    },

    async loadMailingLists() {
      if (this.restClient != null) {
        try {
          this.allMailingLists = await this.restClient.getMailingLists();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadClientMailingDetails() {
      if (this.selectedClientMailingId != null) {
        if (this.restClient != null) {
          try {
            this.clientMailingDetails = await this.restClient.getMailingRecipient(this.selectedClientMailingId);
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        this.clientMailingDetails = this.getDefaultRecipientData();

        this.clientMailingDetails.createdBy = CreatedBy.mailingManagement;
        this.clientMailingDetails.mailingRecipient!.mailingLists = [];
      }

      this.hasChanges = false;
      this.emailHasChanged = false;
    },

    reloadDetailsView() {
      if (this.selectedClientMailingId != null) {
        this.clientMailingDetails = null;

        this.loadClientMailingDetails();
      } else {
        this.closeDetails();
      }
    },

    getDefaultRecipientData() {
      return { ...defaultClientMailingJson() };
    },

    //START set cached data

    //END set cached data

    selectDetailsMode(mode: string) {
      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Empfänger:in hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Empfänger:in bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Empfänger:in";
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    stopEditMode() {
      if (!this.hasChanges) {
        this.selectDetailsMode("show");
        this.reloadDetailsView();
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.selectDetailsMode("show");
          this.reloadDetailsView();
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.clientMailingDetails != null) {
        this.validation = validateClientMailingRecipientJson(this.clientMailingDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    async resendDoubleOptInMail() {
      if (this.clientMailingDetails != null && this.clientMailingDetails.ID != null) {
        if (this.hasChanges) {
          alert("Bitte speichern Sie zuerst Ihre Änderungen.");
        } else {
          this.loadingGeneral = true;

          try {
            await this.restClient.resendMailingRecipientDoubleOptInMail(this.clientMailingDetails.ID);
            alert("Es wurde eine E-Mail zur Bestätigung versendet.");
            this.loadingGeneral = false;
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        }
      }
    },

    async addNewRecipient() {
      if (this.clientMailingDetails != null) {
        this.loadingGeneral = true;
        this.submitValidation = true;

        this.validation = validateClientMailingRecipientJsonManagementAdd(this.clientMailingDetails);

        if (this.validation != null && this.validation.isValid == true) {
          try {
            let memberDetails = await this.restClient.addMailingRecipient(this.clientMailingDetails);
            alert(
              "Empfänger:in erfolgreich hinzugefügt und Bestätigungslink versendet. Nachdem die E-Mail Adresse bestätigt wurde, ist die Anmeldung vollständig und aktiv."
            );
            this.$nextTick(() => {
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.submitValidation = false;
              this.stopEditMode();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          alert("Empfänger:in konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async saveClientMailingDetails() {
      if (this.clientMailingDetails != null) {
        if (this.hasChanges) {
          this.loadingGeneral = true;
          this.submitValidation = true;

          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = validateClientMailingRecipientJson(this.clientMailingDetails);
          //todo ###END

          if (this.validation != null && this.validation.isValid == true) {
            if (this.restClient != null) {
              try {
                let updatedMemberDetails = await this.restClient.updateMailingRecipient(this.clientMailingDetails);

                this.hasChanges = false;
                this.loadingGeneral = false;
                this.submitValidation = false;

                //TODO: Validation error loest alert auch aus -> prüfen
                alert("Die Änderungen wurden erfolgreich gespeichert.");

                if (this.emailHasChanged) {
                  let c = confirm(
                    "Die E-Mail Adresse wurde geändert. Wollen Sie jetzt die E-Mail zur Bestätigung senden?"
                  );

                  if (c) {
                    await this.resendDoubleOptInMail();
                  } else {
                    //do nothing
                  }
                }

                this.stopEditMode();
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            alert("Die Änderungen konnten nicht gespeichert werden. Bitte überprüfen Sie Ihre Änderungen.");
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async deleteRecipient() {
      if (this.selectedClientMailingId != null) {
        let c = confirm("Wollen Sie diese:n Empfänger:in wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteMailingRecipient(this.selectedClientMailingId);
              this.closeDetails();
              alert("Empfänger:in wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },
  },

  watch: {
    clientMailingDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },

    clientMailingEmail: {
      handler(val, oldVal) {
        if (oldVal !== undefined && val != oldVal) {
          if (this.clientMailingDetails != null && this.clientMailingDetails.mailingRecipient != null) {
            this.emailHasChanged = true;
            this.clientMailingDetails.mailingRecipient.state = MailingRecipientStatus.confirmationPending;
          }
        }
      },
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    clientMailingEmail(): string | undefined {
      if (this.clientMailingDetails != null && this.clientMailingDetails.contact != null) {
        return this.clientMailingDetails.contact.email;
      }
    },

    getRecipientMailingListNames(): string | undefined {
      if (
        this.clientMailingDetails != null &&
        this.clientMailingDetails.mailingRecipient != null &&
        this.clientMailingDetails.mailingRecipient.mailingLists != null
      ) {
        let mailingListNames = [];

        for (let i = 0; i < this.clientMailingDetails.mailingRecipient.mailingLists.length; i++) {
          mailingListNames.push(this.clientMailingDetails.mailingRecipient.mailingLists[i].name);
        }

        if (mailingListNames.length <= 0) {
          return "Keiner Liste zugeordnet";
        } else {
          return mailingListNames.join(", ");
        }
      }
    },
  },
});
